import styles from "./Elo.module.css";

export const Elo = ({ tier = "UNRANKED", division = "" }) => {
  if (tier === "") tier = "UNRANKED";
  if (
    tier === "CHALLENGER" ||
    tier === "GRANDMASTER" ||
    tier === "MASTER" ||
    tier === "UNRANKED"
  )
    division = "";
  return (
    <div className={styles.elo}>
      <img
        src={`https://cdn5.xdx.gg/emblem32/${tier.toLowerCase()}.webp`}
        srcSet={`https://cdn5.xdx.gg/emblem32/${tier.toLowerCase()}.webp 32w,
                             https://cdn5.xdx.gg/emblem64/${tier.toLowerCase()}.webp 64w,
                             https://cdn5.xdx.gg/emblem96/${tier.toLowerCase()}.webp 96w`}
        width="32"
        height="32"
        alt={tier.toLowerCase()}
      />
      <div>{division}</div>
    </div>
  );
};

export default Elo;
